/**
 * @generated SignedSource<<4a90e0bf7eaccbe86d337045c689b0d5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveSearchButton_itemSearch$data = {
  readonly pageType: string | null;
  readonly " $fragmentType": "SaveSearchButton_itemSearch";
};
export type SaveSearchButton_itemSearch$key = {
  readonly " $data"?: SaveSearchButton_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SaveSearchButton_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "203c4cfa40a0c2161dfe1d04dc616a5e";

export default node;
